<ion-toolbar class="main-header-toolbar">
    <app-student-header></app-student-header>
</ion-toolbar>

<ion-content [fullscreen]="true" class="content">
    <!--refresher-->
    <ion-refresher class="ion-hide-sm-up" slot="fixed" [pullFactor]="0.5" [pullMin]="100"
                   (ionRefresh)="refresh($event)">
        <ion-refresher-content></ion-refresher-content>

    </ion-refresher>
    <!--refresher end-->

    <ion-grid fixed class="page-grid no-margin-top student-grid student-page" *transloco="let t; read: 'schedulePage'">

        <app-semi-header [title]="'headerComp.headerPopover.testsAndResults'| transloco"></app-semi-header>

        <ion-row class=" ion-no-padding">
            <ion-col size="12" class="ion-no-margin ion-no-padding">
                <app-tabs [styleGroup]="true" [studentStyle]="true" *ngIf="this.examsData">

                    <app-tab [tabTitle]="t('active')" [numberAfter]="this.examsData.upcomingExamsCount"
                             [active]="activeCurrentTestTabs">
                        <ion-row class="study-content ion-no-padding">

                            <ion-col size="12" class="ion-no-padding ion-no-margin white-col top-block">

                                <div class="test-wrapper" *ngIf="this.examsData.upcomingExams.length>0">

                                    <div class="test" *ngFor="let exam of this.examsData.upcomingExams">

                                        <div class="title">{{ exam.title }}</div>

                                        <div class="message">
                                            {{ exam.description }}
                                        </div>

                                        <div class="details">
                                            <div>
                                                <img src="assets/images/icons/calendar.svg" alt="calendar">
                                                {{ t('availableUntil') }} {{ exam.completeTill }}

                                            </div>
                                            <div>
                                                <img src="assets/images/icons/clock.svg" alt="clock">
                                                {{ exam.timeLimit }}   {{ t('minute') }}
                                            </div>
                                            <div>
                                                <img src="assets/images/icons/dumbbells.svg" alt="clock">
                                                {{ exam.triesLimitText }}
                                            </div>

                                        </div>

                                        <div class="btn-wrapper">

                                            <button type="button" class="btn dark-btn" (click)="goToTest(exam.uuid)">
                                                {{ t('doTest') }}
                                            </button>
                                        </div>


                                    </div>

                                </div>


<!--                                <div class="not-test-wrapper" *ngIf="this.examsData.upcomingExamsCount == 0">-->


<!--                                </div>-->


                                <div class="not-test-wrapper" *ngIf="this.examsData.upcomingExamsCount == 0">
<!--                                    <img src="assets/images/student/tests/no_active_tests.png" alt="no active test">-->

                                    <app-dummy [type]="'no_active_tests'" ></app-dummy>

                                </div>

                            </ion-col>

                        </ion-row>
                    </app-tab>

                    <app-tab [tabTitle]=" t('completed') " [active]="completedTestTabs">
                        <ion-row class="study-content ion-no-padding">

                            <ion-col size="12" class="ion-no-padding ion-no-margin white-col top-block">

                                <div class="test-wrapper" *ngIf="this.examsData.completedExams.length>0">

                                    <div class="test" *ngFor="let exam of this.examsData.completedExams">

                                        <div class="title">{{ exam.title }}</div>

                                        <div class="completed">
                                            <img src="assets/images/icons/clock.svg" alt="clock">
                                            {{ t('done') }}: {{ exam?.finishedAt }} {{ exam.completeTime }}
                                        </div>


                                        <div class="message complete">
                                            <div class="result-wrapper">
                                                <div class="title">  {{ t('yourResult') }}:</div>
                                                <div class="score">{{ exam?.mark }}/50

                                                    <div class="score-mark"
                                                         *ngIf="exam?.maxMark === 30 && exam?.evaluation?.online">
                                                        <img src="assets/images/icons/info24x24.svg" alt="info">

                                                        <div class="evaluation-popover d-none">

                                                            <div class="info">

                                                                <img src="assets/images/icons/globe_green.svg"
                                                                     alt="test">

                                                                {{ t('onlineTest') }}: {{ exam.evaluation.online }}/30
                                                            </div>

                                                            <div class="info">

                                                                <img src="assets/images/icons/thought_green.svg"
                                                                     alt="speaking">
                                                                {{ t('speakingPart') }}: {{ exam.evaluation.speaking ?? '-' }}/
                                                                {{ exam.isSpeakingWithEngCourse ? '20' : '10' }}

                                                            </div>
                                                            <div class="info" *ngIf="!exam.isSpeakingWithEngCourse">

                                                                <img src="assets/images/icons/pan_green.svg"
                                                                     alt="writing">
                                                                {{ t('writingPart') }}: {{ exam.evaluation.writing ?? '-' }}
                                                                /10

                                                            </div>


                                                        </div>

                                                    </div>

                                                    <div class="score-mark" *ngIf="exam?.maxMark !== 30">

                                                    </div>


                                                </div>
                                            </div>

                                            <div class="label-score-wrapper">
                                                <img src="assets/images/icons/score_yellow.svg" alt="evaluation failed"
                                                     *ngIf="exam.failed ">

                                                <img src="assets/images/icons/score_green.svg" alt="evaluation"
                                                     *ngIf="!exam.failed">


                                                <div class="score-message d-none" [ngClass]="{'failed':exam.failed}">
                                                    <div *ngIf="exam.failed">
                                                        <div class="title">{{ t('youCanDoBetter') }}</div>
                                                        {{ t('youCanDoBetterText') }}

                                                    </div>

                                                    <div *ngIf="!exam.failed">
                                                        <div class="title">  {{ t('goodJob') }} </div>
                                                       {{ t('goodJobText') }}
                                                    </div>


                                                </div>
                                            </div>


                                        </div>

                                        <div class="details">
                                            <div>
                                                <img src="assets/images/icons/calendar.svg" alt="calendar">
                                                {{ t('availableUntil') }} {{ exam.completeTill }}

                                            </div>
                                            <div>
                                                <img src="assets/images/icons/clock.svg" alt="clock">
                                                {{ exam.timeLimit }}  {{ t('minute') }}
                                            </div>
                                            <div>
                                                <img src="assets/images/icons/dumbbells.svg" alt="clock">
                                                {{ exam.triesLimitText }}
                                            </div>

                                        </div>

                                        <div class="btn-wrapper">
                                            <button type="button" class="btn dark-btn" (click)="goToTest(exam.uuid)"
                                                    *ngIf="!exam.isPast && exam?.triesLeft != 0">
                                                {{ t('tryAgain') }}
                                            </button>

                                            <button type="button" class="btn btn-primary"
                                                    (click)="checkResult(exam.uuid)">
                                                {{ t('results') }}
                                            </button>
                                        </div>


                                    </div>


                                </div>

                                <div class="not-test-wrapper" *ngIf="this.examsData.completedExams.length == 0">

<!--                                    <img *ngIf="this.examsData.upcomingExamsCount == 0"-->
<!--                                         src="assets/images/student/tests/no_completed_no_active.png"-->
<!--                                         alt="no active test">-->
<!--                                    <img *ngIf="this.examsData.upcomingExamsCount != 0"-->
<!--                                         src="assets/images/student/tests/no_completed_with_active.png"-->
<!--                                         alt="no active test">-->

                                    <app-dummy *ngIf="this.examsData.upcomingExamsCount == 0" [type]="'no_completed_no_active'" ></app-dummy>

                                    <app-dummy *ngIf="this.examsData.upcomingExamsCount != 0" [type]="'no_completed_with_active'" ></app-dummy>

                                </div>


                            </ion-col>

                        </ion-row>


                    </app-tab>

                    <app-tab [tabTitle]="t('expired') " [active]="expiredTestTabs">
                        <ion-row class="study-content ion-no-padding">

                            <ion-col size="12" class="ion-no-padding ion-no-margin white-col top-block">

                                <div class="test-wrapper" *ngIf="this.examsData.expiredExams.length>0">

                                    <div class="test" *ngFor="let exam of this.examsData.expiredExams">

                                        <div class="title">{{ exam.title }}</div>


                                        <div class="message terminated">
                                            {{ exam.description }}
                                        </div>


                                        <div class="details">
                                            <div>
                                                <img src="assets/images/icons/calendar.svg" alt="calendar">
                                                {{t('availableUntil')}}<span>{{ exam.completeTill }} </span>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                                <div class="not-test-wrapper" *ngIf="this.examsData.expiredExams.length == 0">

<!--                                    <img *ngIf="this.examsData.completedExams.length == 0 "-->
<!--                                         src="assets/images/student/tests/no_expired_no_completed.png"-->
<!--                                         alt="no active test">-->


                                    <app-dummy *ngIf="this.examsData.completedExams.length == 0" [type]="'no_expired_no_completed'" ></app-dummy>
<!--                                    <img *ngIf="this.examsData.completedExams.length != 0"-->
<!--                                         src="assets/images/student/tests/no_expired_with_completed.png"-->
<!--                                         alt="no active test">-->

                                    <app-dummy *ngIf="this.examsData.completedExams.length != 0" [type]="'no_expired_with_completed'" ></app-dummy>

                                </div>

                                <div class="btn-wrapper" *ngIf="this.examsData.expiredExams.length>0">

                                    <button type="button" class="btn dark-btn"
                                            (click)="openRequestModal('continueAccessTest')">  {{t('requestAccess')}}
                                    </button>
                                </div>

                            </ion-col>

                        </ion-row>


                    </app-tab>


                </app-tabs>


            </ion-col>


            <ion-col size="12" class="ion-no-margin ion-no-padding">

                <app-banners [banners]=""></app-banners>
            </ion-col>


        </ion-row>

    </ion-grid>

    <app-footer></app-footer>

</ion-content>

<app-chats></app-chats>
